import React, { Component, createRef } from 'react';

import { Button } from 'web-store-modules/packages/web-store-ui-library';
import FlyUpModal from '../../ui/modals/FlyUpModal';
import { isMobileDevice } from 'web-store-modules/packages/obsess-device-detector';
import ModalOverlay from '../../ui/modals/ModalOverlay';
import SelfieWidget from '../index';
import html2canvas from 'html2canvas';
import {
    PhotoBoothSnapButtonClicked,
    PhotoBoothDownloadButtonClicked,
    PhotoBoothRetakeButtonClicked
} from '../../../utils/Analytics.js'

const cameraIcon = `https://cdn.obsess-vr.com/general-mills/camera.svg`
const isMobile = isMobileDevice();
import './SelfieModal.css';


class SelfieModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showShareBtn: false,
            showCountDown: false,
            countDown: 3,
        };
        this.modalRef = createRef()
        this.downloadIconRef = createRef()
    }


    removeListeners = () => {
        if (isMobile) {
            window.removeEventListener('touchend', this.handleModalClose);
        } else {
            window.removeEventListener('click', this.handleModalClose);
        }
    }

    handleModalClose = (e) => {
        console.log(e.target)
        if (this.modalRef && this.modalRef.current.contains(e.target)) {
            return;
        }
        this.closeModal();
    }

    closeModal = () => {
        this.props.onModalHidden()
    }

    handleClick = () => {
        const captureImage = document.getElementsByClassName('captureImage');
        if (captureImage.length > 0) {
            PhotoBoothSnapButtonClicked(this.props.currentSceneName)
            this.setState({ showCountDown: true })
            var interval;
            let count = 0
            interval = setInterval(() => {
                if (count === 2) {
                    this.setState({ showShareBtn: true, showCountDown: false, countDown: 3 })
                    captureImage[0].click();
                    clearInterval(interval)
                } else {
                    this.setState({ countDown: (this.state.countDown - 1) })
                }
                count++;
            }, 1000);
        } else {
            alert("Something went wrong.")
        }
    }

    retakeClick = () => {
        PhotoBoothRetakeButtonClicked(this.props.currentSceneName)
        const backToCam = document.getElementById('backToCam');
        if (backToCam) {
            backToCam.click();
            this.setState({ showShareBtn: false })
        } else {
            alert("Something went wrong.")
        }
    }

    downloadSelfie = () => {
        PhotoBoothDownloadButtonClicked(this.props.currentSceneName)
        html2canvas(document.getElementById('selfie-widget-box'))
            .then((canvas) => {
                let dataURL = canvas.toDataURL('image/png');
                this.downloadIconRef.current.download = `selfie.png`;
                this.downloadIconRef.current.href = dataURL;
                this.downloadIconRef.current.click();
            }).catch((err) => {
                console.log('>downloadSelfie Error:', err);
            });
    }

    snapBtn = () => {
        return (
            <>
                <div className="selfie-heading">
                    Take a Photo
                </div>
                <div className="selfie-button-container"><Button
                    hoverStyleChange={false}
                    onClick={this.handleClick}
                    primaryColor={'#0091e1'}
                    secondaryColor={'#FFFFFF'}
                    className="selfie-marker-button flex-center obsessvr-regularFont full-width pointer product-button"
                    style={{ padding: '0', margin: '5px', borderRadius: '50%', height: '4.7em', width: '4.7em', flex: 'none' }}
                    primaryBorderColor='white'
                    secondaryBorderColor='white'
                    primaryBorderWidth='0px'
                    secondaryBorderWidth='0px'
                    insetBorder={true}
                    padded={false}
                >
                    <p className='obsessvr-regularFont' style={{ fontSize: '14px', fontFamily: 'sans-serif' }}>
                        {`SNAP`}
                    </p>
                </Button></div>
            </>
        )
    }


    assetDownloadButton = () => {
        return (
            <>
                <div className="selfie-download-container custom-selfie-btn">
                    <Button
                        hoverStyleChange={false}
                        onClick={this.downloadSelfie}
                        primaryColor={'#0091e1'}
                        secondaryColor={'#FFFFFF'}
                        className="selfie-marker-button flex-center obsessvr-regularFont full-width pointer product-button"
                        style={{ padding: '0', margin: '0 1%', borderRadius: '4px', height: '3em' }}
                        primaryBorderColor='white'
                        secondaryBorderColor='white'
                        primaryBorderWidth='0px'
                        secondaryBorderWidth='0px'
                        insetBorder={true}
                        padded={false}
                    >
                        <p className='obsessvr-regularFont' style={{
                            fontSize: '14px', fontFamily: 'sans-serif'
                        }}>
                            {`DOWNLOAD PHOTO`}
                        </p>
                    </Button>
                </div>
                <div className="selfie-download-container">
                    <Button
                        hoverStyleChange={false}
                        onClick={this.retakeClick}
                        primaryColor={'#FFFFFF'}
                        secondaryColor={'#0091e1'}
                        className="selfie-marker-button flex-center obsessvr-regularFont full-width pointer product-button"
                        style={{ padding: '0', margin: '0 1%', borderRadius: '4px', border: 'solid 1px rgb(0, 145, 225)', height: '3em' }}
                        primaryBorderColor='#0091e1'
                        secondaryBorderColor='#0091e1'
                        primaryBorderWidth='0px'
                        secondaryBorderWidth='0px'
                        insetBorder={true}
                        padded={false}
                    >
                        <img src={cameraIcon} />
                        <p className='obsessvr-regularFont' style={{ fontSize: '14px', fontFamily: 'sans-serif', color: '#0091e1' }}>
                            {`RETAKE`}
                        </p>
                    </Button>
                </div>

            </>
        )
    }

    renderModalContent = () => {
        return (
            <div className='selfie-modal-content' style={{ textAlign: 'center' }} ref={this.modalRef}>

                    <div className="selfieWrapper" id="selfie-widget-box">
                        <SelfieWidget
                            status={true}
                            onCLoseCallback={e => this.setState({ showSelfieWidget: false })}
                        />
                        <div className='selfieFrame'/>
                    </div>

                    {this.state.showCountDown && <div className="selfie-count-down">
                        <span>{this.state.countDown}</span>
                    </div>}

                {this.state.showShareBtn ? this.assetDownloadButton() : this.snapBtn()}
                <a ref={this.downloadIconRef} download="selfie.png" style={{ display: 'none', position: 'absolute', right: '-1em', zIndex: '-9999' }}></a>
            </div>
        )
    }

    render() {
        return (
            //Added the isImage Loaded bool here to display the close button on the Modal due to a condition in Modal.jsx
            <FlyUpModal extraClassName="selfie-modal-container" onModalHidden={this.props.onModalHidden} isOpaque
                textPopup hideCloseIcon isImageLoaded>
                <div className="selfie-close-modal" onClick={() => this.props.onModalHidden()}>
                    <img className="selfie-close-icon" src="https://cdn.obsess-vr.com/modal-close-icon-normal.png" />
                </div>
                <ModalOverlay />
                {this.renderModalContent()}
            </FlyUpModal>
        );
    }
}

export default SelfieModal;